export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";